import { FilterFacet } from '@apgnext/project/legacy/js/overrides/molecules/toolbar/types';
import React from 'react';
import styles from '../Toolbar.module.scss';
import { ReactComponent as IconChevronDown } from '@srcDS/icons/tailwind-icons/icon-cheveron-down.svg';
import { ReactComponent as IconChevronUp } from '@srcDS/icons/tailwind-icons/icon-cheveron-up.svg';
import { useFacetTitle } from '../utils/getFacetTitle';

interface FilterTitleProps {
  filter: FilterFacet;
  activeFilter: FilterFacet | null;
  closeFilterModal: ( e: React.MouseEvent) => void;
  openFilterModal: (filter: FilterFacet, e: React.MouseEvent) => void;
}

export const FilterTitle: React.FC<FilterTitleProps> = ({
  filter,
  activeFilter,
  closeFilterModal,
  openFilterModal,
}) => {
  const toggleFilterModal = (filter: FilterFacet, event: React.MouseEvent) => {
    event.stopPropagation();
    if (activeFilter?.attributeId === filter.attributeId) {
      closeFilterModal(event);
      return;
    }
    openFilterModal(filter, event);
  };

  const filterTitle = useFacetTitle(filter);

  if (!filterTitle) return null;

  return (
    <div className={styles.filterContainer} onClick={(e) => toggleFilterModal(filter, e)}>
      <p className={styles.filterTitle}>{filterTitle}</p>
      {activeFilter?.attributeId === filter.attributeId ? (
        <IconChevronUp className={styles.arrowIcon} />
      ) : (
        <IconChevronDown className={styles.arrowIcon} />
      )}
    </div>
  );
};
